import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes from "model";
import EDEStatementsEnrollmentPreferencesPage from "components/EDEStatements/pages/EDEStatementsEnrollmentPreferencesPage";

/**
 * @name CaptureEDEStatementsEnrollmentDeliveryOption
 * @returns {React.Component}
 * @description A capture in the "EDE eStatement Enrollment" capture group.
 */
export default function CaptureEDEStatementsEnrollmentDeliveryOption(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    return <EDEStatementsEnrollmentPreferencesPage />;
}